export default "__VITE_ASSET__DUMWA32g__"